import { loader } from 'graphql.macro'
import { intercomConnection } from '../../intercomConnection'

export default async function createNewTicket ({ dataLoaders, variables }) {
  const schema = loader('./createNewTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: { ticketParams: variables.ticketParams } })
  intercomConnection.trackEvent('ticket_created', {})
  return response.createNewTicket
}
